export const STATUS = {
  DEFAULT: 1,
  NORMAL: 200,
  DISABLED: 300,
  DELETE: 400,
} as const;
